




import {Component, Prop, Vue} from 'vue-property-decorator';
import {CREDIT_ENTRY_METHOD, PaymentMethodData, ITokenizeResult, WebService} from '@customer-portal/shared';

interface IMerchantValidationEvent extends Event {
	validationURL: string;
	complete: (session: Record<string, any>) => void;
}

@Component({
	components: {}
})
export default class ApplePayButton extends Vue {
	@Prop({required: true})
	locationId!: string;

	@Prop({required: true})
	label!: string;

	@Prop({required: true})
	total!: number;

	paymentRequestConfig: PaymentMethodData | null = null;

	async created() {
		if(this.locationId) {
			this.paymentRequestConfig = await WebService.getPaymentRequestConfig(this.locationId, CREDIT_ENTRY_METHOD.APPLE_PAY);
		}
	}

	async start() {
		if(this.locationId && this.paymentRequestConfig) {
			let request: PaymentRequest;
			if(window.PaymentRequest) {
				request = new PaymentRequest(
					[this.paymentRequestConfig],
					this.getDetails()
				);
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				request.onmerchantvalidation = async (event: IMerchantValidationEvent) => {
					console.log(event);
					if(this.locationId) {
						const session = await WebService.getPaymentSession(this.locationId, CREDIT_ENTRY_METHOD.APPLE_PAY, event.validationURL);
						console.log(session);
						event.complete(session);
					}
				};
				const response = await request.show();
				console.log(response);
				try {
					const signedToken = await WebService.tokenize(this.locationId, CREDIT_ENTRY_METHOD.APPLE_PAY, response.details.token);
					console.log(signedToken);
					await response.complete('success');
					const payload: ITokenizeResult = {
						signedToken: signedToken,
						accountId: null,
						cvv: null
					};
					this.$emit('payload', payload);
				} catch(error) {
					console.error(error);
					await response.complete('fail');
					this.$emit('error', error);
				}
			} else {
				this.$emit('error', 'Apple Pay is not supported in this browser');
				this.$q.dialog({
					title: 'Error',
					message: 'Your Browser does not support payment. Please use Safari or Chrome'
				});
			}
		}
	}

	getDetails() {
		return {
			total: {
				label: this.label,
				amount: {
					value: (this.total / 100).toString(),
					currency: 'USD'
				}
			}
		};
	}
}
